import {
  BOOKING_GET_LIST_DELTA,
  BOOKING_GET_LIST_DELTA_SUCCESS,
  BOOKING_GET_LIST_DELTA_ERROR,
  BOOKING_GET_LIST_WITH_FILTER,
  BOOKING_GET_LIST_WITH_ORDER,
  BOOKING_GET_LIST_SEARCH,
  BOOKING_ADD_ITEM,
  BOOKING_ADD_ITEM_SUCCESS,
  BOOKING_ADD_ITEM_ERROR,
  BOOKING_CREATE_ITEM,
  BOOKING_CREATE_ITEM_SUCCESS,
  BOOKING_CREATE_ITEM_ERROR,
  BOOKING_INVOKE_KEY,
  BOOKING_INVOKE_KEY_SUCCESS,
  BOOKING_INVOKE_KEY_ERROR,
  CHANGE_LANGUAGE_FOR_BOOKING_ITEMS,
  BOOKING_SHOW_TOAST_SET,
  BOOKING_ADD_ITEM_BEFORE_API_REQUEST_SUCCESS,
  EASEE_GET_ADMIN_USERS,
  EASEE_GET_ADMIN_USERS_SUCCESS,
  EASEE_GET_ADMIN_USERS_ERROR
} from "../actions";

import { arrayToObject } from "../../helpers/Utils";
import { addSoftFields } from "./saga";

const INIT_STATE = {
  allBookingItems: {},
  bookingItems: [],
  error: "",
  showToast: false,
  filter: null,
  searchKeyword: "",
  orderColumn: { column: "updated_at", label: "Last Update", direction: "desc" },
  loading: false,
  invokeBookingLoading: false,
  addBookingLoading: false,
  createBookingLoading: false,
  createBookingItems: "",
  createBookingError: "",
  AdminUserList: {},
  labels: [{ label: "VIP", color: "secondary" }, { label: "PREMIUM", color: "primary" }, { label: "GOLD", color: "info" }],
  orderColumns: [
    { column: "updated_at", label: "Last Update", direction: "desc" },
    { column: "created_at", label: "Creation Date", direction: "desc" }
  ],
  categories: [],
  selectedItems: []
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case BOOKING_GET_LIST_DELTA:
      return { ...state, loading: true };

    case BOOKING_GET_LIST_DELTA_SUCCESS: {
      const { items, allLoaded } = action.payload;
      if (items.length > 0) {
        let allBookingItemsObj = arrayToObject(items, "id");
        allBookingItemsObj = { ...state.allBookingItems, ...allBookingItemsObj };
        return {
          ...state,
          loading: false,
          allBookingItems: allBookingItemsObj,
          bookingItems: [...Object.values(allBookingItemsObj)]
        };
      }
      return {
        ...state,
        loading: false,
        allLoaded
      };
    }

    case BOOKING_GET_LIST_DELTA_ERROR:
      return { ...state, loading: false, error: action.payload };

    case BOOKING_GET_LIST_WITH_FILTER: {
      const { column, value } = action.payload;
      // const fullList = ["awaiting_approval", "hotel_guest", "invalid_booking", "checked_out"];
      let newValue = value ? value : [];
      newValue = typeof newValue === "string" ? [newValue] : newValue;
      const unFilteredItems = Object.values(state.allBookingItems);

      if (newValue.length < 1 || column === "" || value === "") {
        return {
          ...state,
          bookingItems: unFilteredItems,
          filter: null,
          searchKeyword: ""
        };
      }

      const filteredItems = unFilteredItems.filter(bookingItemValue => {
        return newValue.indexOf(bookingItemValue[column]) > -1;
      });

      return {
        ...state,
        bookingItems: filteredItems,
        filter: {
          column,
          value: newValue
        },
        searchKeyword: ""
      };
    }

    case BOOKING_GET_LIST_WITH_ORDER: {
      if (action.payload === "" || action.payload.column === "") {
        return {
          ...state,
          bookingItems: state.bookingItems,
          orderColumn: { column: "updated_at", label: "Last Update", direction: "desc" }
        };
      }
      const sortedItems =
        action.payload.direction === "asc"
          ? state.bookingItems.sort((a, b) => {
            if (a[action.payload.column] < b[action.payload.column]) return -1;
            if (a[action.payload.column] > b[action.payload.column]) return 1;

            return 0;
          })
          : state.bookingItems.sort((a, b) => {
            if (a[action.payload.column] > b[action.payload.column]) return -1;
            if (a[action.payload.column] < b[action.payload.column]) return 1;

            return 0;
          });
      return {
        ...state,
        bookingItems: sortedItems,
        orderColumn: state.orderColumns.find(x => x.column === action.payload.column)
      };
    }

    case BOOKING_GET_LIST_SEARCH: {
      if (action.payload === "") {
        return {
          ...state,
          searchKeyword: null,
          bookingItems: [...Object.values(state.allBookingItems)],
          filter: null,
          orderColumn: { column: "updated_at", label: "Last Update", direction: "desc" }
        };
      }
      const keyword = action.payload.toLowerCase();

      const searchItems = Object.keys(state.allBookingItems).reduce((r, e) => {
        const toReturn = r;
        if (
          (state.allBookingItems[e].title && state.allBookingItems[e].title.toLowerCase().indexOf(keyword) > -1) ||
          (state.allBookingItems[e].staff_summary && state.allBookingItems[e].staff_summary.toLowerCase().indexOf(keyword) > -1) ||
          (state.allBookingItems[e].status && state.allBookingItems[e].status.toLowerCase().indexOf(keyword) > -1) ||
          (state.allBookingItems[e].service &&
            state.allBookingItems[e].service.name &&
            state.allBookingItems[e].service.name.toLowerCase().indexOf(keyword) > -1) ||
          (state.allBookingItems[e].fullName && state.allBookingItems[e].fullName.toLowerCase().indexOf(keyword) > -1) ||
          (state.allBookingItems[e].label && state.allBookingItems[e].label.toLowerCase().indexOf(keyword) > -1) ||
          (state.allBookingItems[e].rooms &&
            state.allBookingItems[e].rooms
              .join(" ")
              .toLowerCase()
              .indexOf(keyword) > -1)
        )
          toReturn[e] = state.allBookingItems[e];
        return toReturn;
      }, {});

      return {
        ...state,
        bookingItems: [...Object.values(searchItems)],
        searchKeyword: action.payload,
        filter: null,
        orderColumn: { column: "updated_at", label: "Last Update", direction: "desc" }
      };
    }
    case BOOKING_ADD_ITEM:
      return { ...state, addBookingLoading: true };

    case BOOKING_ADD_ITEM_SUCCESS: {
      const allBookingItemsObj = { ...state.allBookingItems, [action.payload.id]: action.payload };
      return {
        ...state,
        addBookingLoading: false,
        allBookingItems: { ...allBookingItemsObj },
        bookingItems: [...Object.values(allBookingItemsObj)]
      };
    }
    case BOOKING_ADD_ITEM_BEFORE_API_REQUEST_SUCCESS: {
      const allBookingItemsObj = { ...state.allBookingItems, [action.payload.id]: action.payload };
      return {
        ...state,
        allBookingItems: { ...allBookingItemsObj },
        bookingItems: [...Object.values(allBookingItemsObj)]
      };
    }

    case BOOKING_ADD_ITEM_ERROR:
      return { ...action.payload.snapshot, addBookingLoading: false, error: action.payload.error, showToast: true };

    case EASEE_GET_ADMIN_USERS:
      return { ...state, loading: true, AdminUserList: null };

    case EASEE_GET_ADMIN_USERS_SUCCESS: {
      return {
        ...state,
        loading: false,
        AdminUserList: action.payload
      };
    }
    case EASEE_GET_ADMIN_USERS_ERROR:
      return { ...state, loading: false, error: action.payload };

    case BOOKING_CREATE_ITEM:
      return { ...state, createBookingLoading: true };

    case BOOKING_CREATE_ITEM_SUCCESS: {
      return {
        ...state,
        createBookingLoading: false,
        createBookingItems: action.payload
      };
    }

    case BOOKING_CREATE_ITEM_ERROR:
      return { createBookingLoading: false, createBookingError: action.payload.error };

    case BOOKING_INVOKE_KEY:
      return { ...state, addBookingLoading: true, invokeBookingLoading: true };

    case BOOKING_INVOKE_KEY_SUCCESS: {
      return {
        ...state,
        addBookingLoading: false,
        invokeBookingLoading: false,
        invokeKey: action.payload
      };
    }

    case BOOKING_INVOKE_KEY_ERROR:
      return {
        ...state,
        addBookingLoading: false,
        invokeBookingLoading: false,
        error: action.payload,
        showToast: true
      };

    case CHANGE_LANGUAGE_FOR_BOOKING_ITEMS: {
      const allBookingItemsArrInLocale = Object.values(state.allBookingItems).map(booking => {
        const { locale, timeZone } = action.payload;
        return addSoftFields(booking, locale, timeZone);
      });
      const allBookingItemsObjLocale = arrayToObject(allBookingItemsArrInLocale, "id");

      return {
        ...state,
        allBookingItems: allBookingItemsObjLocale,
        bookingItems: [...Object.values(allBookingItemsObjLocale)]
      };
    }

    case BOOKING_SHOW_TOAST_SET:
      return { ...state, showToast: action.payload };
    default:
      return state;
  }
};
